import { render, staticRenderFns } from "./ReviewPage.v1.vue?vue&type=template&id=41721b86&scoped=true&"
import script from "./ReviewPage.v1.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.v1.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage.v1.vue?vue&type=style&index=0&id=41721b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41721b86",
  null
  
)

export default component.exports